module.exports = __webpack_public_path__ + "static/media/11_Presto.191eecec.png";